import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Button from "../../Common/Button";
import Dock from "../../Common/Dock";

export default class SidePanel extends PureComponent {
  static propTypes = {
    panelVisibility: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    isMobile: PropTypes.bool,
    isVisible: PropTypes.bool,
    position: PropTypes.string
  };

  static defaultProps = {
    children: null,
    isVisible: true,
    isMobile: false,
    position: ""
  };

  get dockSize() {
    return !this.props.isMobile || (window.innerWidth >= 768 && window.innerWidth < 1025) ? 0.5 : 1;
  }

  handleVisibleChange = () => this.props.panelVisibility(false);

  render() {
    return (
      <Dock position={this.props.position} isVisible={this.props.isVisible} onVisibleChange={this.handleVisibleChange} size={this.dockSize}>
        {this.props.isMobile ? (
          <Button
            onClick={this.handleVisibleChange}
            className={classNames("side-panel__close-mobile", this.props.isVisible && "--visible")}
            icon="back"
          />
        ) : (
          <Button onClick={this.handleVisibleChange} className={classNames("side-panel__close", this.props.isVisible && "--visible")} icon="x" />
        )}
        <div className="side-panel">{this.props.children}</div>
      </Dock>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/SidePanel.js